<script>
	/** @type {String} */
	export let description;
	/** @type {number} */
	export let duplicatesAmount;
	/** @type {String} */
	export let duplicatesAmountDescription;
	/** @type {String} */
	export let title;
	/** @type {number} */
	export let uniqueOffers500mToSubway;
	/** @type {String} */
	export let uniqueOffers500mToSubwayDescription;
	/** @type {number} */
	export let uniqueOffersWithPriceChangeDown;
	/** @type {String} */
	export let uniqueOffersWithPriceChangeDownDescription;
	/** @type {number} */
	export let uniqueOffersForRenovation;
	/** @type {String} */
	export let uniqueOffersForRenovationDescription;
</script>

<section>
	<div class="interesting-numbers">
		<div class="copy">
			<h2>
				{@html title}
			</h2>
			<p>
				{@html description}
			</p>
		</div>
		<ul class="number-tiles">
			<li>
				<h3>{uniqueOffers500mToSubway}</h3>

				<p>{@html uniqueOffers500mToSubwayDescription}</p>
				<!-- <Button
					href={`${lang ? `/${lang}` : ''}/${$t('global.explore_url')}/${$t(
						'global.rent_url'
					)}/warszawa?distance_to_subway={"max":500}`}
				>
					{$t('global.Flats close to subway')}
				</Button> -->
			</li>

			<li>
				<h3>{uniqueOffersWithPriceChangeDown}</h3>

				<p>{@html uniqueOffersWithPriceChangeDownDescription}</p>
				<!-- <p>{@html $t('global.live listings with <strong>price change detected</strong>')}</p>
					{@html uniqueOffers500mToSubwayDescription}
				<Button
					href={`${lang ? `/${lang}` : ''}/${$t('global.explore_url')}/${$t(
						'global.sale_url'
					)}/warszawa/${$t('global.list-with-map_url')}?price_change=["down"]`}
				>
					{$t('global.Find a price deal')}
				</Button> -->
			</li>
			<li>
				<h3>{duplicatesAmount}</h3>

				<p>{@html duplicatesAmountDescription}</p>
				<!-- <p>
					{@html $t(
						'global.<strong>duplicated offers detected</strong> on {{sourcesAmount}} different websites',
						{
							// @ts-ignore
							sourcesAmount: 9
						}
					)}
				</p>
				<Button href={`${lang ? `/${lang}` : ''}/${$t('global.explore_url')}`}>
					{$t('global.Start exploring')}
				</Button> -->
			</li>
			<li>
				<h3>{uniqueOffersForRenovation}</h3>

				<p>{@html uniqueOffersForRenovationDescription}</p>
				<!-- <p>{@html $t('global.flats & apartments <strong>for renovation</strong>')}</p>
				<Button
					href={`${lang ? `/${lang}` : ''}/${$t('global.explore_url')}/${$t(
						'global.sale_url'
					)}/warszawa?interior_standard=[0]`}
				>
					{$t('global.Flats for renovation')}
				</Button> -->
			</li>
		</ul>
	</div>
</section>

<style>section{padding:1rem}.interesting-numbers{background:hsla(var(--hsl-primary),.15);border-radius:1.5rem;display:grid;grid-gap:3rem;gap:3rem;padding:1.25rem;align-content:center;justify-content:center;place-content:center;align-items:center;justify-items:stretch;place-items:center stretch;max-width:var(--layout-width);margin:4rem auto}@media (max-width:1024px){.interesting-numbers{gap:1.75rem;padding:1.25rem;margin-bottom:0}}@media (min-width:1024.02px){.interesting-numbers{border-radius:1.5rem;grid-template-columns:1fr 1fr;padding:2rem}}.interesting-numbers :global(strong){color:hsla(var(--hsl-primary));font-weight:bolder}.copy{display:grid;grid-gap:1rem;gap:1rem}@media (min-width:1024.02px){.copy{padding:2rem}}h2{font:var(--f-heading-md-semibold);text-align:center}@media (min-width:767.02px){h2{font:var(--f-heading-lg-semibold);text-align:left}}.number-tiles{display:grid;grid-template-columns:repeat(auto-fit,minmax(15rem,1fr));grid-gap:1.25rem;gap:1.25rem}.number-tiles li{background:hsla(var(--hsl-white));border-radius:1.25rem;box-shadow:var(--shadow-sm);display:grid;grid-gap:.75rem;gap:.75rem;list-style:none;padding:1.25rem;text-align:center}.number-tiles li h3{color:hsla(var(--hsl-primary));font:700 40px/100% var(--ff)}.number-tiles li p{font:var(--f-ui-sm-medium);margin-bottom:.75rem}</style>
